"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSynchronizeStore = void 0;
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const useSynchronizeStore = (control, setFormState, clearErrors, setAuthError, debugMode) => {
    const synchronizeStoreForm = (0, react_1.useCallback)((0, lodash_debounce_1.default)((values) => {
        setAuthError(false);
        setFormState(values);
        clearErrors();
    }, 1), []);
    const newValues = (0, react_hook_form_1.useWatch)({ control });
    (0, react_1.useEffect)(() => {
        synchronizeStoreForm(newValues);
        if (debugMode)
            console.log('sync store', newValues);
    }, [newValues]);
};
exports.useSynchronizeStore = useSynchronizeStore;
